import { useLocalStorage } from "usehooks-ts";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { unAuthorisedUserPostcodeInLocalStorageKey } from "../../../../discovery/v2/DiscoveryV2Home";

export const useStorefrontBuyerPostcode = () => {
  const { business } = useSellarCurrentBusiness();
  const [unAuthorisedUserPostcode] = useLocalStorage<string | undefined>(
    unAuthorisedUserPostcodeInLocalStorageKey,
    undefined,
  );

  const businessPostcode =
    business?.type === "retailer" ? business.DeliveryAddress.postalCode : null;

  return {
    buyerPostcode: businessPostcode || unAuthorisedUserPostcode || "",
  };
};
